module.exports = __webpack_public_path__ + "static/media/education.9c66870a.svg";